import { Swatches } from './swatches';
import { Dimensions, Platform } from 'react-native';
import { normalizeText } from '../../utils/scaling-utils';
export const theme = {
    buttonPaddingHorizontal: 15,
    navBarHeight: 60,
    navBarPaddingTop: 5,
    navBarPaddingBottom: 10,
    miniplayerHeight: 60,
    defaultCardAspectRatio: 16 / 9,
    defaultCardHeight: Math.min(175, Dimensions.get('window').width / 2.6) || 175,
    reactiveProperties: {
        horizontalGutter: {
            1600: 300,
            1200: 200,
            800: 100,
            700: 80,
            0: 10,
        },
        horizontalGutterCarousel: {
            1200: 50,
            800: 40,
            0: 10,
        },
    },
    gutter: {
        0: 10 * 0,
        1: 10 * 1,
        2: 10 * 2,
        3: 10 * 3,
        4: 10 * 4,
    },
    darkColors: {
        primary: Swatches.LIGHT_GREY,
        secondary: Swatches.WHITE,
        accent: Swatches.CYAN,
        black: Swatches.BLACK,
        white: Swatches.WHITE,
        grey0: Swatches.LIGHT_GREY,
        grey3: Swatches.GREY,
        grey5: Swatches.DARK_GREY,
        red: Swatches.RED,
        textPrimary: Swatches.LIGHT_GREY,
        textSecondary: Swatches.WHITE,
        textInverted: Swatches.BLACK,
        backgroundPrimary: Swatches.BLACK,
        backgroundSecondary: Swatches.BLACK,
        backgroundInverted: Swatches.WHITE,
        backgroundTabBar: Swatches.DARK_GREY,
        borderPrimary: Swatches.GREY,
        borderSecondary: Swatches.GREY,
        borderLight: Swatches.LIGHT_GREY,
        sliderThumb: Swatches.WHITE,
        sliderTrack: Swatches.GREY,
        sliderProgress: Swatches.CYAN,
        skeletonLoader: Swatches.LIGHT_GREY,
    },
    lightColors: {
        primary: Swatches.BLACK,
        secondary: Swatches.GREY,
        accent: Swatches.CYAN,
        black: Swatches.BLACK,
        white: Swatches.WHITE,
        grey0: Swatches.LIGHT_GREY,
        grey3: Swatches.GREY,
        grey5: Swatches.DARK_GREY,
        red: Swatches.RED,
        textPrimary: Swatches.BLACK,
        textSecondary: Swatches.GREY,
        textInverted: Swatches.WHITE,
        backgroundPrimary: Swatches.WHITE,
        backgroundSecondary: Swatches.WHITE,
        backgroundInverted: Swatches.BLACK,
        backgroundTabBar: Swatches.LIGHT_GREY,
        borderPrimary: Swatches.GREY,
        borderSecondary: Swatches.GREY,
        borderLight: Swatches.LIGHT_GREY,
        sliderThumb: Swatches.BLACK,
        sliderTrack: Swatches.GREY,
        sliderProgress: Swatches.CYAN,
        skeletonLoader: Swatches.LIGHT_GREY,
    },
    fontSizes: {
        h1: 28,
        h2: 22,
        h3: 18,
        h4: 16,
        primary: 14,
        small: 13,
        xsmall: 10,
        icon: 20,
    },
    components: {
        Button: (props, { buttonPaddingHorizontal, fontSizes, colors, }) => {
            let color = props.type === 'clear' ? colors.textPrimary : colors.textInverted;
            if ((props.color === 'secondary' && props.type === 'clear') || props.type === 'outline') {
                color = colors.accent;
            }
            else if (props.color === 'warning') {
                color = colors.warning;
            }
            else if (props.color === 'error') {
                color = colors.error;
            }
            let borderWidth = 0;
            let borderColor = 'transparent';
            let backgroundColor = colors.accent;
            if (props.type === 'clear') {
                backgroundColor = 'transparent';
            }
            else if (props.type === 'outline') {
                borderWidth = 2;
                borderColor = colors.accent;
                backgroundColor = 'transparent';
            }
            return {
                titleStyle: {
                    fontWeight: 'bold',
                    fontSize: normalizeText(fontSizes.primary),
                    color,
                },
                style: {
                    marginLeft: props.isLeftAligned ? buttonPaddingHorizontal * -1 : undefined,
                    marginRight: props.isRightAligned ? buttonPaddingHorizontal * -1 : undefined,
                },
                buttonStyle: {
                    opacity: props.disabled ? 0.25 : 1,
                    paddingVertical: 10,
                    paddingHorizontal: buttonPaddingHorizontal,
                    borderRadius: 10,
                    backgroundColor,
                    borderColor,
                    borderWidth,
                },
            };
        },
        Card: (_props, theme) => ({
            containerStyle: {
                borderRadius: 10,
                elevation: 4,
                borderWidth: 0,
                backgroundColor: theme.colors.backgroundPrimary,
            },
        }),
        CardTitle: {},
        CardFeaturedTitle: (_props, theme) => ({
            style: {
                color: theme.colors.textPrimary,
                textAlign: 'center',
                fontWeight: '500',
            },
        }),
        CardFeaturedSubtitle: {
            style: {
                textAlign: 'center',
            },
        },
        CarouselStandard: (props, theme) => ({
            autoplayLoop: true,
            autoplayLoopKeepAnimation: true,
            showPagination: (props?.carousel?.slides?.length || 0) > 1 ? true : false,
            autoplay: true,
            autoplayDelay: 5,
            paginationStyleItem: {
                marginLeft: 5,
                marginRight: 5,
                maxHeight: 15,
                maxWidth: 15,
                borderRadius: 99999,
                elevation: 1,
            },
            paginationStyleItemActive: {
                backgroundColor: theme.colors.grey5,
            },
            paginationStyleItemInactive: {
                backgroundColor: theme.colors.grey3,
            },
            gradientColor: "black",
            descriptionTextColor: "white",
        }),
        BuyButton: (_props, theme) => ({
            buttonStyle: {
                backgroundColor: theme.colors.secondary,
                paddingHorizontal: 25,
            },
            titleStyle: {
                color: theme.colors.black,
            },
            iconStyle: {
                color: theme.colors.black,
                fontSize: normalizeText(12),
                margin: 2,
                marginLeft: 0,
                marginHorizontal: theme.gutter[1],
            },
        }),
        IconButton: (props, theme) => ({
            containerStyle: props?.containerStyle,
            style: {
                color: props?.activated && props?.activeIconColor ? props?.activeIconColor : theme.colors.textPrimary,
                margin: 0,
                opacity: props?.disabled === true ? 0.25 : 1,
            },
            size: normalizeText(28),
        }),
        PlayCollectionButton: (_, { colors }) => ({
            iconColor: colors.textInverted,
            iconContainerStyle: {
                backgroundColor: 'transparent',
                marginRight: 10,
            },
        }),
        Description: (_props, { fontSizes }) => ({
            containerStyle: {
                backgroundColor: 'transparent',
                marginTop: normalizeText(fontSizes.primary * 1.5),
            },
        }),
        RenderHtml: (props, { colors, fontSizes }) => {
            let lineHeight = normalizeText(fontSizes.primary * 1.5);
            let textAlign = props?.center ? 'center' : 'left';
            if (Platform.OS === 'web') {
                lineHeight = `${lineHeight}px`;
            }
            return {
                baseStyle: {
                    color: props?.color || (props?.inverted ? colors.textInverted : colors.textPrimary),
                    fontSize: normalizeText(fontSizes.primary),
                    lineHeight,
                    textAlign,
                },
            };
        },
        ListItem: (_props, theme) => ({
            bottomDivider: true,
            containerStyle: {
                backgroundColor: theme.colors.backgroundPrimary,
                borderColor: `${theme.colors.backgroundInverted}80`,
            },
        }),
        ListItemAccordion: (_props, theme) => ({
            containerStyle: {
                backgroundColor: theme.colors.backgroundPrimary,
            },
        }),
        ListItemSubtitle: (_props, theme) => ({
            numberOfLines: 3,
            style: {
                color: theme.colors.textPrimary,
                fontSize: normalizeText(theme.fontSizes.primary),
                lineHeight: normalizeText(theme.fontSizes.primary * 1.5),
            },
        }),
        ListItemSwipeable: (_props, theme) => ({
            containerStyle: {
                backgroundColor: theme.colors.backgroundPrimary,
                borderColor: `${theme.colors.backgroundInverted}80`,
            },
        }),
        ListItemTitle: (_props, theme) => ({
            numberOfLines: 2,
            style: {
                color: theme.colors.textPrimary,
                marginBottom: 5,
                fontWeight: 'bold',
                fontSize: normalizeText(theme.fontSizes.h3),
            },
        }),
        ListItemInput: (_props, theme) => ({
            selectionColor: theme.colors.borderPrimary,
            cursorColor: theme.colors.borderPrimary,
            style: {
                textAlign: 'left',
                color: theme.colors.textPrimary,
                borderBottomColor: theme.colors.borderPrimary,
                borderBottomWidth: 1
            }
        }),
        Input: (_props, theme) => ({
            selectionColor: theme.colors.borderPrimary,
            cursorColor: theme.colors.borderPrimary,
            style: {
                textAlign: 'left',
                color: theme.colors.textPrimary,
                borderBottomColor: theme.colors.borderPrimary,
                borderBottomWidth: 1
            }
        }),
        Filter: (_props, theme) => ({
            overlayStyle: {
                backgroundColor: theme.colors.backgroundPrimary,
                width: '75%',
                maxHeight: '75%',
            }
        }),
        ActionBar: (_props, { gutter, colors }) => ({
            leftBarStyle: {
                flex: 4,
                backgroundColor: 'transparent',
                justifyContent: 'flex-start',
            },
            rightBarStyle: {
                flex: 1,
                justifyContent: 'flex-end',
                backgroundColor: 'transparent',
            },
            fullBarStyle: {
                marginTop: 10,
                width: '100%',
            },
            buttonStyle: {
                backgroundColor: colors.secondary,
                width: '90%',
                borderRadius: 10,
                margin: 10,
            },
            filterIconStyle: {
                color: colors.black,
                fontSize: normalizeText(25),
                marginHorizontal: gutter[1],
            },
            textStyle: {
                color: colors.black,
            },
            tagIconSize: normalizeText(28),
            tagIconStyle: {},
            shareIconSize: normalizeText(28),
            shareIconStyle: {},
            moreIconStyle: {
                marginLeft: gutter[2],
            },
        }),
        ButtonBar: (_props) => ({
            iconStyle: {
                fontSize: normalizeText(25),
                opacity: 0.65,
            },
            containerStyle: {
                width: '100%',
            },
        }),
        EllipsisButton: (_props, theme) => ({
            listIconSize: normalizeText(25),
        }),
        BookmarkButton: (_props, theme) => ({
            activeIconColor: theme.colors.accent,
        }),
        Broadcast: (_props, theme) => ({
            tintColor: theme.colors.textPrimary,
            airplayStyle: {
                width: 50,
                height: 50,
                margin: 10,
            },
            bluetoothStyle: {
                width: 45,
                height: 44,
            },
        }),
        JumpButton: ({ direction } = {}, theme) => {
            const size = normalizeText(30);
            return {
                size,
                containerStyle: {
                    paddingHorizontal: 10,
                },
                iconStyle: {
                    color: theme.colors.textPrimary,
                },
                textStyle: {
                    position: 'absolute',
                    top: size * 0.6,
                    fontSize: 10,
                    fontWeight: 'bold',
                    right: direction === 'forward' ? size * 0.8 : undefined,
                    left: direction !== 'forward' ? size * 0.8 : undefined,
                },
            };
        },
        ChapterSkipButton: (_props, theme) => ({
            containerStyle: {
                paddingHorizontal: 20,
            },
            iconStyle: {
                color: theme.colors.textPrimary,
                fontSize: normalizeText(30),
            },
        }),
        MiniPlayer: (_props, { miniplayerHeight, colors }) => ({
            miniplayerHeight: miniplayerHeight,
            containerStyle: {
                borderTopColor: colors.borderLight,
                borderTopWidth: 1,
                backgroundColor: colors.backgroundSecondary,
                height: miniplayerHeight,
            },
            trackTitleStyle: {
                paddingRight: 15,
                paddingHorizontal: 10
            },
            titleTouchableStyle: {
                height: '100%',
                justifyContent: 'center',
            },
            trackTitleContainerStyle: {
                justifyContent: 'center',
                flexGrow: 1,
                flexShrink: 1,
            },
            buttonContainerStyle: {
                flexGrow: 0,
                flexShrink: 0,
                justifyContent: 'center',
            },
            playButtonContainerStyle: {
                paddingLeft: 20,
            },
            playButtonStyle: {
                fontSize: Math.min(normalizeText(30), (miniplayerHeight - 20)),
                color: colors.textPrimary,
                alignContent: 'center',
                alignItems: 'center',
                alignSelf: 'center',
                justifyContent: 'center',
            },
        }),
        VideoPlayer: (_props, { miniplayerHeight, colors }) => ({
            miniplayerHeight,
            miniplayerContainer: {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: miniplayerHeight,
                backgroundColor: colors.backgroundSecondary,
                borderTopColor: colors.borderLight,
                borderTopWidth: 1,
                justifyContent: 'center',
            },
            metaContainer: {
                backgroundColor: 'transparent',
            },
            infoContainer: {
                justifyContent: 'center',
                flexGrow: 1,
                flexShrink: 1,
                backgroundColor: 'transparent',
            },
            buttonContainer: {
                flexGrow: 0,
                flexShrink: 0,
                justifyContent: 'center',
                backgroundColor: 'transparent',
            },
            playButtonStyle: {
                fontSize: Math.min(normalizeText(30), (miniplayerHeight - 20)),
                color: colors.textPrimary,
                alignContent: 'center',
                alignItems: 'center',
                alignSelf: 'center',
                justifyContent: 'center',
            },
            playButtonContainer: {},
        }),
        PlaybackSpeed: (_, { colors }) => ({
            titleStyle: {
                fontSize: normalizeText(18),
            },
            presetButtonProps: {
                disabledStyle: {
                    opacity: 1,
                    borderWidth: 1,
                    borderColor: colors.borderSecondary,
                },
            },
        }),
        OptionButton: (_props, { colors }) => ({
            iconStyle: {
                color: colors.textPrimary,
                fontSize: normalizeText(40),
            },
        }),
        PlayButton: ({ size } = {}, { colors }) => ({
            iconSize: normalizeText(size === 'lg' ? 50 : 30),
            iconStyle: {
                color: colors.accent,
            },
        }),
        TagButton: {
            size: normalizeText(28),
        },
        ProgressButton: (_, { colors }) => ({
            size: normalizeText(28),
            iconColor: colors.textPrimary,
            activeIconColor: colors.accent,
        }),
        FavoriteButton: (_, theme) => ({
            size: normalizeText(28),
            activeColor: theme.colors.red,
        }),
        TextTicker: (props, theme) => ({
            scrollSpeed: 20,
            marqueeDelay: 5000,
            bounce: false,
            style: {
                color: theme.colors.textPrimary,
                fontSize: normalizeText(theme.fontSizes.primary),
                fontWeight: props?.bold === true ? 'bold' : undefined,
            },
        }),
        DownloadButton: {
            size: normalizeText(28),
        },
        ShareButton: {
            size: normalizeText(28),
        },
        CarouselDisplay: (_props, theme) => ({
            containerStyle: {
                marginBottom: theme.gutter[1],
            },
            titleContainerStyle: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                width: '100%',
                backgroundColor: 'transparent',
                marginBottom: 10,
            },
            titleStyle: {
                textAlign: 'left',
                fontWeight: 'bold',
                fontSize: normalizeText(theme.fontSizes.h1),
                color: theme.colors.textPrimary,
            },
            titleChevronStyle: {
                fontSize: normalizeText(theme.fontSizes.h1 * 0.75),
                marginLeft: 25,
            },
            flatListStyle: {},
            scrollControlContainerStyle: {
                height: theme.defaultCardHeight,
                position: 'absolute',
                zIndex: 1,
                width: 100,
                alignItems: 'center',
                justifyContent: 'center',
            },
            scrollControlIconStyle: {
                textShadowColor: theme.colors.backgroundPrimary,
                textShadowRadius: 7,
                textShadowOffset: {
                    width: 0,
                    height: 0,
                },
            },
        }),
        ListItemBase: ({
            listItemContainerStyle: {
                flexDirection: 'column',
            },
            listItemContentStyle: {
                marginLeft: 20,
            },
            listItemSubtitleStyle: {
                textAlign: 'left',
            },
            childrenContainerStyle: {
                marginTop: 10,
                width: '100%',
            },
            touchableStyle: {
                flexDirection: 'row',
                width: '100%',
            },
        }),
        ListItemButtons: (_props, { gutter }) => ({
            fullBarStyle: {
                backgroundColor: 'transparent',
                justifyContent: 'flex-start',
                width: '100%',
            },
        }),
        ListItemAvatar: () => {
            const AVATAR_WIDTH = normalizeText(100);
            const AVATAR_BORDER_RADIUS = 10;
            return ({
                containerStyle: {
                    borderRadius: AVATAR_BORDER_RADIUS,
                    overflow: 'hidden',
                },
                lockedBackgroundStyle: {
                    opacity: 0.5,
                    backgroundColor: 'black',
                },
                lockedStyle: {
                    width: '100%',
                    height: '100%',
                    alignItems: 'center',
                    justifyContent: 'center',
                },
                lockStyle: {
                    color: 'white',
                    opacity: 0.75,
                },
                width: AVATAR_WIDTH,
                borderRadius: AVATAR_BORDER_RADIUS,
            });
        },
        Series: {
            listItemContainerStyle: {},
        },
        Search: {
            listItemContainerStyle: {},
        },
        ContentBody: (_props, { gutter, colors }) => ({
            dataStyle: {
                backgroundColor: colors.backgroundPrimary,
                padding: gutter[1],
            },
            titleContainerStyle: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'baseline',
                marginBottom: gutter[1],
            },
            titleStyle: {
                marginTop: gutter[1],
                marginRight: 10,
            },
            titleSkeletonStyle: {
                marginBottom: gutter[1],
            },
            durationStyle: {
                marginBottom: gutter[1],
            }
        }),
        PlayerHandle: () => ({
            handleStyle: {},
            handleIconStyle: {
                size: 30,
            },
        }),
        FullPlayer: (_props, { gutter }) => ({
            contentContainerStyle: {
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'visible',
            },
            innerContainerStyle: {
                justifyContent: 'space-evenly',
                width: '100%',
                maxHeight: '100%',
                paddingHorizontal: gutter[3],
                flexGrow: 1,
            },
            handleContainerStyle: {
                width: '100%',
                flexDirection: 'row',
                justifyContent: 'space-between',
            },
            seekBarContainerStyle: {
                width: '100%',
                alignItems: 'center',
                marginBottom: gutter[3],
            },
            playerBarStyle: {
                alignSelf: 'flex-end',
            },
            audioButtonContainerStyle: {
                justifyContent: 'center',
                marginHorizontal: 50,
                marginVertical: 50,
                marginBottom: 50,
                marginTop: gutter[2],
            }
        }),
        CardThemed: (props, { gutter, colors, fontSizes }) => {
            let marginLeft = 0;
            let marginRight = 0;
            if (props?.padLeft === true) {
                marginLeft = gutter[1];
            }
            else if (typeof props?.padLeft === 'number') {
                marginLeft = props.padLeft;
            }
            if (props?.padRight === true) {
                marginRight = gutter[1];
            }
            else if (typeof props?.padRight === 'number') {
                marginRight = props.padRight;
            }
            return {
                cardWidthBase: marginLeft + marginRight,
                maxTitleLines: 1,
                cardStyle: {
                    padding: 0,
                    marginTop: 0,
                    marginBottom: 0,
                    marginLeft,
                    marginRight,
                    borderWidth: 0,
                    elevation: 0,
                    backgroundColor: 'transparent',
                    shadowColor: 'transparent',
                    overflow: 'visible',
                },
                imageContainerStyle: {
                    borderRadius: 5,
                    overflow: 'hidden',
                },
                imageStyle: {
                    borderRadius: 5,
                },
                downloadProgressLabelColor: colors.white,
                progressColor: colors.accent,
                progressStyle: {
                    position: 'absolute',
                    bottom: 0,
                    height: 6,
                    zIndex: 2000,
                },
                featuredTitleStyle: {
                    fontSize: normalizeText(fontSizes.primary),
                    textAlign: 'left',
                    marginTop: 0,
                },
                featuredSubtitleStyle: {
                    textAlign: 'left',
                },
                skeletonTextStyle: {
                    marginVertical: gutter[1],
                },
            };
        },
        CardOverlay: (props, { colors }) => {
            const blur = props?.blur || 7;
            return {
                blur,
                lockStyle: {
                    textShadowColor: colors.backgroundPrimary,
                    textShadowRadius: blur,
                    textShadowOffset: {
                        width: 0,
                        height: 0,
                    },
                    padding: blur,
                    margin: blur * -1,
                },
                overlayContainerStyle: {
                    position: 'absolute',
                    height: '100%',
                    width: '100%',
                    alignItems: 'flex-end',
                    justifyContent: 'flex-end',
                    zIndex: 1,
                    padding: blur,
                },
            };
        },
        Avatar: (_props, { colors }) => ({
            containerStyle: {
                backgroundColor: colors.secondary,
                marginTop: 10,
                alignSelf: 'center',
            },
        }),
        Icon: (_, theme) => ({
            color: theme.colors.textPrimary,
        }),
        ThemedSlider: (_, theme) => ({
            minimumTrackTintColor: theme.colors.accent,
            maximumTrackTintColor: theme.colors.grey2,
        }),
        Text: ({ bold, xsmall, small }, { fontSizes, colors }) => ({
            style: {
                color: colors.textPrimary,
                fontWeight: bold == true ?
                    'bold' :
                    (bold === false ? 'normal' : undefined),
                fontSize: xsmall ?
                    normalizeText(fontSizes.xsmall) :
                    (small ? normalizeText(fontSizes.small) : undefined)
            },
            h1Style: {
                fontSize: normalizeText(fontSizes.h1),
            },
            h2Style: {
                fontSize: normalizeText(fontSizes.h2),
            },
            h3Style: {
                fontSize: normalizeText(fontSizes.h3),
            },
            h4Style: {
                fontSize: normalizeText(fontSizes.h4),
            },
        }),
        ContentButtons: () => ({
            iconSize: normalizeText(28),
        }),
        AppearsIn: (_, { fontSizes, colors, gutter }) => ({
            containerStyle: {
                flexDirection: 'row',
                flexWrap: 'wrap',
                marginBottom: gutter[1],
            },
            buttonContainerStyle: {},
            buttonTextStyle: {
                fontSize: normalizeText(fontSizes.primary),
                textDecorationLine: 'underline',
                color: colors.accent,
            },
            buttonDemarcatorTextStyle: {
                fontSize: normalizeText(fontSizes.primary),
                marginHorizontal: 5,
                color: colors.borderPrimary,
            },
        }),
        DescriptionMask: (_, { colors }) => ({
            containerStyle: {
                alignItems: 'center',
                backgroundColor: 'transparent',
                width: '100%',
            },
            buttonTitleStyle: {
                color: colors.backgroundInverted,
            },
        }),
    }
};
//# sourceMappingURL=index.js.map